/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientInput } from './ClientInput';
export type UpdateZoneCommand = {
    name: string;
    number?: number;
    availableInPriceList: boolean;
    type: UpdateZoneCommand.type;
    /**
     * UUIDs of zones to assign to the combined zone.
     */
    zoneIds?: Array<string>;
    /**
     * Localizations.
     */
    localizations: Array<ClientInput>;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace UpdateZoneCommand {
    export enum type {
        SIMPLE = 'SIMPLE',
        COMBINED = 'COMBINED',
        ALL_NETWORK = 'ALL_NETWORK',
    }
}

